import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Activity from '../../components/Activity';
import ButtonModal from '../../components/ModalConfirmation/ButtonModal';
import LeadIvrOpenNewCanceled from './LeadIvrOpenNewCanceled';
import axios from '../../services/axios';
import ErrorProcessor from '../../components/ErrorProcessor';

export default function LeadHistory({ lead, stateAction, stateInfo }) {
  const [leadHistory, setHistory] = useState([]);
  const [leadData, setLeadData] = useState(lead);
  const [apiErrors, setApiErrors] = useState({});

  const getLead = useCallback(async () => {
    try {
      const request = await axios.get(`leads/${leadData.id}`);
      setLeadData({
        ...request.data,
      });
    } catch (err) {
      setApiErrors(err);
    } finally {
      stateAction(false);
    }
  }, [leadData]);

  useEffect(() => {
    const historyActivity = [];
    historyActivity.push({
      name: moment(leadData.created_at).format('DD/MM/YY HH:mm'),
      text: (
        <span className="subtitle text-gray-500 fw-bold ps-0 pt-0 text-sm">
          {leadData.protocol}
        </span>
      ),
      time: leadData.Channel.name,
      icon: 'time-1',
    });

    if (leadData.History) {
      leadData.History.forEach((value) => {
        const channelLead = value.LeadIvrOpenNewCanceled ? (
          <LeadIvrOpenNewCanceled lead={value} updateLeadData={getLead} />
        ) : (
          <div />
        );
        historyActivity.push({
          name: moment(value.created_at).format('DD/MM/YY HH:mm'),
          text: (
            <ButtonModal
              link
              message={channelLead}
              buttonProps={{
                className: 'subtitle text-primary fw-bold ps-0 pt-0 text-sm',
              }}
              modalProps={{ noFooter: true, fullScreen: true }}
              textModal={{
                title: `${value.name} - ${value.protocol}`,
              }}
            >
              {value.protocol}
            </ButtonModal>
          ),
          time: value.Channel.name,
          icon: 'time-1',
        });
      });
    }

    historyActivity.sort((a, b) => {
      return (
        moment(a.name, 'DD/MM/YY HH:mm').valueOf() -
        moment(b.name, 'DD/MM/YY HH:mm').valueOf()
      );
    });

    setHistory(historyActivity);
  }, [leadData]);

  useEffect(() => {
    async function updateLead() {
      try {
        await getLead();
      } catch (error) {
        console.error(error);
      }
    }

    if (stateInfo === true) {
      updateLead();
    }
  }, [stateInfo]);

  return (
    <>
      <ErrorProcessor error={apiErrors} />
      <Activity
        title={`Contatos do lead ${leadData.name}`}
        data={leadHistory}
      />
    </>
  );
}

LeadHistory.propTypes = {
  lead: PropTypes.shape({
    History: PropTypes.arrayOf(PropTypes.shape({})),
    protocol: PropTypes.string,
    name: PropTypes.string,
    Channel: PropTypes.shape({ name: PropTypes.string }),
    created_at: PropTypes.string,
    LeadIvrOpenNewCanceled: PropTypes.shape({}),
  }).isRequired,
  stateInfo: PropTypes.bool.isRequired,
  stateAction: PropTypes.func.isRequired,
};
